import { useTranslations } from 'use-intl';
import { z } from 'zod';
import { enMessages } from './messages';

export const StoreLocaleCodeSchema = z.union([
   z.literal('en-us'),
   z.literal('en-gb'),
   z.literal('en-ca'),
   z.literal('en-au'),
   z.literal('en-eu'),
   z.literal('fr-ca'),
   z.literal('fr-fr'),
   z.literal('de-de'),
   z.literal('it-it'),
   z.literal('es-es'),
]);

export type EnMessages = typeof enMessages;

export type LocaleCode = z.infer<typeof StoreLocaleCodeSchema>;

export type TranslationFunction = ReturnType<typeof useTranslations>;
